import {yup} from 'libs/yup'

export const schema = yup.object().shape({
  message: yup.string().notRequired().max(10000).label('メッセージ'),
})

export type Schema = yup.InferType<typeof schema>
